import service from '@/utils/request'
import { socket } from '@/api/websocket'
import { getUserData } from '@/auth/utils'

// One subscription per authorized chat, shared by the app and its open chat.
export function createMessageChangeNotifications(vm) {
  const userId = getUserData()?.id
  const channels = new Map()
  const revisions = new Map()
  const handled = new Set()
  let stopped = false
  let listRequest = 0

  async function handleChange(event) {
    if (stopped || String(getUserData()?.id) !== String(userId) || !event?.chat_id || !event?.message_id) return
    if (event.event_id && handled.has(event.event_id)) return
    if (event.event_id) {
      handled.add(event.event_id)
      if (handled.size > 500) handled.delete(handled.values().next().value)
    }
    const key = `${event.chat_id}:${event.message_id}`
    const revision = (revisions.get(key) || 0) + 1
    revisions.set(key, revision)
    try {
      const response = await service.get(
        `/chats/${event.chat_id}/message-changes/${event.message_id}`,
        { validateStatus: status => status < 500 }
      )
      if (stopped || String(getUserData()?.id) !== String(userId) || revisions.get(key) !== revision || !response?.data?.chat_id) return
      const change = { ...event, ...response.data }
      vm.$root.$emit('chat-message-changed', change)
      if (String(event.actor_id) !== String(userId)) {
        vm.playNotificationSound()
        await vm.getUserLiveData()
      }
    } catch (error) {
      console.error('Unable to refresh changed chat message', error)
    }
  }

  function subscribe(data) {
    if (stopped || String(getUserData()?.id) !== String(userId)) return
    const lists = [data?.chatsContacts, data?.broadcasts]
    const ids = new Set()
    lists.forEach(list => Object.values(list || {}).forEach(item => {
      const id = item?.chat?.real_id || item?.chat?.id || item?.chat_id
      if (/^\d+$/.test(String(id))) ids.add(String(id))
    }))
    ids.forEach(id => {
      if (!channels.has(id)) {
        const channel = socket.private(`Chat.Messages.${id}`)
        channel.listen('.chat.message.changed', handleChange)
        channels.set(id, channel)
      }
    })
  }

  async function refresh() {
    if (!userId || stopped || String(getUserData()?.id) !== String(userId)) return
    const requestId = ++listRequest
    try {
      const response = await service.get('/chats', {
        validateStatus: status => status < 500,
      })
      if (stopped || requestId !== listRequest) return
      subscribe(response.data)
    } catch (error) {
      console.error('Unable to subscribe to message changes', error)
    }
  }

  vm.$root.$on('chat-list-loaded', subscribe)
  socket.channel('broadcasts').listen('.broadcast.created', refresh)
  socket.channel(`User.LiveData.${userId}`).listen('.LiveData', refresh)
  socket.channel(`App.User.${userId}`).listen('.GotMessage', refresh)
  refresh()

  return {
    stop() {
      stopped = true
      vm.$root.$off('chat-list-loaded', subscribe)
      socket.channel('broadcasts').stopListening('.broadcast.created', refresh)
      socket.channel(`User.LiveData.${userId}`).stopListening('.LiveData', refresh)
      socket.channel(`App.User.${userId}`).stopListening('.GotMessage', refresh)
      channels.forEach((channel, id) => {
        channel.stopListening('.chat.message.changed', handleChange)
        socket.leave(`Chat.Messages.${id}`)
      })
      channels.clear()
    },
  }
}
